import { IAppState } from '../../redux';

export function selectOfferId(state: IAppState): number | null {
  return state.offer.id;
}
